import {
  TbBallFootball,
  TbBarbell,
  TbBell,
  TbBike,
  TbBuildingCommunity,
  TbCalendarEvent,
  TbChecklist,
  TbMessageCircle,
  TbMoodKid,
  TbMusic,
  TbSchool,
  TbStretching,
  TbStretching2,
  TbSwimming,
  TbTicket,
  TbUsersGroup,
  TbYoga,
} from "react-icons/tb";
import { TRIAL_DAYS } from "../../../constants/trial";
import { LANDING_PRICE_FROM } from "../HomeLanding/landingSeo";
import { BASE } from "./nav";

const PRICE = new Intl.NumberFormat("ru-RU").format(Number(LANDING_PRICE_FROM) || 0);

function nichePhotos(id, heroPos) {
  return {
    hero: `/landing/niche/${id}/hero.jpg`,
    split: `/landing/niche/${id}/split.jpg`,
    heroPos,
  };
}

const COACH_TAB = {
  id: "coach",
  label: "Тренеру",
  title: ["Группа и журнал —", "в одном экране"],
  text: "Тренер видит свои группы и расписание, открывает журнал занятия и отмечает пришедших. Остатки абонементов обновятся сами.",
  points: ["Свои группы и расписание", "Журнал посещений", "Карточки учеников"],
  screens: ["mock-owner-calendar.png", "mock-owner-journal.png", "mock-owner-clients.png"],
};

const BRAND_TAB = {
  id: "brand",
  label: "Бренд клуба",
  title: ["Ваш клуб,", "а не чужой сервис"],
  text: "Логотип, обложка и цвета клуба, лента новостей и участники. Брендинг подключается модулем или входит в тариф «Про».",
  points: ["Логотип и цвета", "Лента клуба", "Свой экран загрузки"],
  screens: ["mock-brand-splash.png", "mock-brand-club.png", "mock-brand-manage.png"],
};

const CLIENT_SCREENS = ["mock-client-calendar.png", "mock-client-home.png", "mock-client-chat.png"];

const ADULT_TAB = {
  id: "client",
  label: "Клиентам",
  title: ["Расписание и абонемент", "всегда под рукой"],
  text: "Клиент видит расписание, свои посещения и остаток абонемента, оплачивает онлайн и пишет в чат клуба.",
  points: ["Расписание клуба", "Остаток и оплата", "Чат с клубом"],
  screens: CLIENT_SCREENS,
};

const PARENT_TAB = {
  id: "client",
  label: "Родителям",
  title: ["Всё о занятиях", "ребёнка рядом"],
  text: "Родитель видит расписание, посещения и остаток абонемента, оплачивает онлайн и пишет в чат клуба — без звонков тренеру.",
  points: ["Расписание и посещения", "Остаток и оплата", "Чат с клубом"],
  screens: CLIENT_SCREENS,
};

function appTabs(clientTab = PARENT_TAB, coachLabel = COACH_TAB.label) {
  return [{ ...COACH_TAB, label: coachLabel }, clientTab, BRAND_TAB];
}

const MEMBERSHIP_RULE = [
  TbTicket,
  "Абонементы под вашу систему",
  "По количеству занятий или по сроку действия, с заморозкой. Разовые занятия — тоже.",
];

const RESCHEDULE_RULE = [
  TbCalendarEvent,
  "Переносы без обзвона",
  "Изменили время занятия — ученики и родители получают push-уведомление.",
];

const COMMON_FAQ = [
  [
    "Можно ли принимать оплату онлайн?",
    "Да, в тарифах «Клуб» и «Про». Подключите ЮKassa или Т-Банк в настройках клуба — оплата абонемента проходит в приложении, деньги приходят на счёт клуба.",
  ],
  [
    "Как перенести списки учеников?",
    "Сохраните таблицу из Excel или Google Таблиц в CSV и загрузите — ученики появятся в базе клуба.",
  ],
  [
    "Сколько стоит?",
    `От ${PRICE} ₽ в месяц за клуб. Первые ${TRIAL_DAYS} дней — полный доступ бесплатно, без привязки карты.`,
  ],
];

const PARENT_FAQ = [
  "Как родители видят информацию о ребёнке?",
  "Родитель открывает приложение клуба по ссылке: видит расписание, посещения и остаток абонемента, может оплатить и написать в чат. Кабинет клиента входит в тариф «Клуб» и выше или подключается модулем.",
];

const JOURNAL_FAQ = [
  "Где смотреть посещения и остатки?",
  "Тренер отмечает пришедших в журнале — занятия списываются с абонемента автоматически. Остаток видно в карточке ученика и в приложении клуба.",
];

export const NICHE_PAGES = {
  edinoborstva: {
    id: "edinoborstva",
    path: `${BASE}/dlya-edinoborstv`,
    navTitle: "Единоборства",
    navText: "Карате, дзюдо, бокс, ММА",
    icon: TbUsersGroup,
    pill: "Для клубов и школ единоборств",
    heroLines: ["Дисциплина в зале.", "Порядок в клубе."],
    heroLead:
      "Группы, журнал посещений, абонементы и связь с родителями — в одном сервисе для школ единоборств.",
    classLead:
      "На татами открываете занятие из расписания и отмечаете пришедших — остаток абонемента и посещение уходят к родителю сами.",
    sports: ["Карате", "Дзюдо", "Бокс", "Самбо", "Тхэквондо", "ММА", "Кикбоксинг"],
    photos: { hero: "/landing/niche/hero.jpg", split: "/landing/niche/split.jpg" },
    stat: { value: 186, delta: "9%" },
    lesson: { meta: "Сегодня · 18:00 · татами 1", title: "Дзюдо, младшая группа", came: 14, total: 16 },
    strip: [
      [TbUsersGroup, "Группы по возрасту", "Детские и взрослые составы, тренеры и залы."],
      [TbChecklist, "Журнал на татами", "Отметили группу — занятия списались сами."],
      [TbTicket, "Абонементы и долги", "Остатки, оплаты и должники без тетради."],
      [TbMessageCircle, "Родители на связи", "Расписание, остаток и чат в приложении."],
    ],
    painsTitle: ["Группы растут.", "Тетрадь уже не справляется."],
    pains: [
      [
        "Состав группы — в тетради тренера",
        "Кто занимается в младшей группе, знает только тренер. Заболел тренер — и никто не понимает, кто должен прийти.",
        "Составы групп в одной базе",
      ],
      [
        "Остаток занятий считают вручную",
        "Родитель спрашивает, сколько тренировок осталось, а администратор листает записи за месяц.",
        "Остаток считается сам",
      ],
      [
        "Родители пишут тренеру в личку",
        "Переносы, оплата и вопросы по абонементу теряются в переписке с десятками семей.",
        "Чат и уведомления клуба",
      ],
    ],
    dayKicker: "Один вечер в школе",
    dayTitle: ["Тренер ведёт занятие.", "Учёт ведётся сам."],
    daySub:
      "Младшая группа заканчивает тренировку, взрослая выходит на татами. Никаких тетрадей и пересчёта абонементов.",
    day: [
      ["До", "Расписание дня", "Какие группы, в каком зале и у какого тренера."],
      ["На татами", "Отметка в журнале", "Тренер отмечает пришедших за минуту."],
      ["После", "Учёт уже готов", "Занятия списаны, родители видят посещение."],
    ],
    appTitle: ["Тренеру, родителям", "и ученикам"],
    appTabs: appTabs(),
    appNote: "«Тигр» — пример клуба единоборств внутри приложения.",
    rulesTitle: ["Настраивается под то,", "как вы уже работаете."],
    rules: [
      [
        TbUsersGroup,
        "Детские и взрослые группы",
        "Направления и группы по возрасту или уровню подготовки — у каждой свой тренер, зал и расписание.",
      ],
      MEMBERSHIP_RULE,
      [
        TbBuildingCommunity,
        "Несколько залов",
        "Филиалы и залы в одном кабинете — у каждого своё расписание, тренеры и группы.",
      ],
      RESCHEDULE_RULE,
    ],
    regTitle: ["Запустите школу", "в Бай.Спорт сегодня"],
    faq: [
      [
        "Подойдёт ли сервис для детских и взрослых групп?",
        "Да. Заводите направления и группы по возрасту или уровню, назначайте тренеров и залы. Детские и взрослые составы живут в одном расписании.",
      ],
      PARENT_FAQ,
      JOURNAL_FAQ,
      ...COMMON_FAQ,
    ],
  },

  tancy: {
    id: "tancy",
    path: `${BASE}/dlya-tancev`,
    navTitle: "Танцы",
    navText: "Студии и школы танцев",
    icon: TbMusic,
    pill: "Для танцевальных школ и студий",
    heroLines: ["Ритм на сцене.", "Порядок в студии."],
    heroLead:
      "Направления, группы, журнал посещений, абонементы и связь с учениками — в одном сервисе для танцевальных школ.",
    classLead:
      "В студии открываете класс из расписания и отмечаете пришедших — остаток абонемента сразу виден ученику.",
    sports: ["Хип-хоп", "Балет", "Contemporary", "Бальные танцы", "Джаз-фанк", "Стретчинг"],
    photos: nichePhotos("tancy", "0% 50%"),
    stat: { value: 142, delta: "12%" },
    lesson: { meta: "Сегодня · 19:00 · зал 2", title: "Хип-хоп, начинающие", came: 11, total: 14 },
    strip: [
      [TbMusic, "Направления и залы", "Хип-хоп, балет, стретчинг — у каждого своё расписание."],
      [TbChecklist, "Журнал занятий", "Отметили класс — занятия списались сами."],
      [TbTicket, "Абонементы и разовые", "Пакеты, сроки и разовые визиты без таблиц."],
      [TbMessageCircle, "Ученики на связи", "Расписание, остаток и чат в приложении."],
    ],
    painsTitle: ["Студия растёт.", "Таблицы уже не справляются."],
    pains: [
      [
        "Расписание в нескольких таблицах",
        "Залы, педагоги и направления живут в разных файлах. Любой перенос — ручная правка и рассылка.",
        "Одно расписание студии",
      ],
      [
        "Кто пришёл — помнит только педагог",
        "После занятия посещения переписывают в таблицу, а остаток абонемента считают вручную.",
        "Журнал и остатки сами",
      ],
      [
        "Ученики спрашивают одно и то же",
        "Во сколько класс, сколько занятий осталось, как оплатить — вопросы идут в личку педагогу.",
        "Ответы — в приложении клуба",
      ],
    ],
    dayKicker: "Вечер в студии",
    dayTitle: ["Педагог ведёт класс.", "Учёт ведётся сам."],
    daySub:
      "В одном зале заканчивается детская хореография, в соседнем начинается хип-хоп для взрослых. Никаких таблиц и пересчёта абонементов.",
    day: [
      ["До", "Расписание дня", "Какие классы, в каком зале и у какого педагога."],
      ["В зале", "Отметка в журнале", "Педагог отмечает пришедших за минуту."],
      ["После", "Учёт уже готов", "Занятия списаны, ученик видит остаток."],
    ],
    appTitle: ["Педагогам, ученикам", "и родителям"],
    appTabs: appTabs({
      id: "client",
      label: "Ученикам",
      title: ["Расписание и абонемент", "всегда под рукой"],
      text: "Ученик видит расписание студии, свои посещения и остаток абонемента, оплачивает онлайн и пишет в чат — без звонков администратору.",
      points: ["Расписание студии", "Остаток и оплата", "Чат со студией"],
      screens: CLIENT_SCREENS,
    }, "Педагогу"),
    appNote: "«Тигр» — демонстрационный клуб внутри приложения.",
    rulesTitle: ["Настраивается под то,", "как работает ваша студия."],
    rules: [
      [
        TbMusic,
        "Несколько направлений",
        "Хип-хоп, балет, стретчинг — у каждого направления свои группы, педагоги и залы.",
      ],
      MEMBERSHIP_RULE,
      [
        TbBuildingCommunity,
        "Залы и филиалы",
        "Все залы и адреса студии в одном кабинете — у каждого своё расписание и педагоги.",
      ],
      RESCHEDULE_RULE,
    ],
    regTitle: ["Запустите студию", "в Бай.Спорт сегодня"],
    faq: [
      [
        "Подойдёт ли для студии с несколькими направлениями?",
        "Да. Заводите направления и группы, назначайте педагогов и залы — всё живёт в одном расписании студии.",
      ],
      [
        "Можно ли продавать разовые занятия?",
        "Да. Кроме абонементов по количеству занятий или по сроку, можно отмечать разовые посещения.",
      ],
      JOURNAL_FAQ,
      ...COMMON_FAQ,
    ],
  },

  gimnastika: {
    id: "gimnastika",
    path: `${BASE}/dlya-gimnastiki`,
    navTitle: "Гимнастика",
    navText: "Художественная и спортивная",
    icon: TbStretching,
    pill: "Для секций и школ гимнастики",
    heroLines: ["Точность на ковре.", "Порядок в секции."],
    heroLead:
      "Группы по возрасту и уровню, журнал посещений, абонементы и связь с родителями — в одном сервисе для секций гимнастики.",
    classLead:
      "В зале открываете группу из расписания и отмечаете пришедших — остаток абонемента и посещение уходят к родителю сами.",
    sports: ["Художественная", "Спортивная", "Акробатика", "Батут", "Чирлидинг"],
    photos: nichePhotos("gimnastika"),
    stat: { value: 164, delta: "7%" },
    lesson: { meta: "Сегодня · 17:30 · зал 1", title: "Художественная, 6–8 лет", came: 10, total: 12 },
    strip: [
      [TbUsersGroup, "Группы по возрасту", "От малышей до старших — свой тренер и зал."],
      [TbChecklist, "Журнал занятий", "Отметили группу — занятия списались сами."],
      [TbTicket, "Абонементы и оплаты", "Остатки, оплаты и должники без тетради."],
      [TbMessageCircle, "Родители на связи", "Расписание, остаток и чат в приложении."],
    ],
    painsTitle: ["Групп всё больше.", "Тетрадь уже не справляется."],
    pains: [
      [
        "Составы групп — в голове тренера",
        "Кто в какой группе и кто перешёл на следующий уровень, администратор узнаёт из переписки.",
        "Составы групп в одной базе",
      ],
      [
        "Остаток занятий считают вручную",
        "Родитель спрашивает, сколько тренировок осталось, а администратор листает записи за месяц.",
        "Остаток считается сам",
      ],
      [
        "Родители пишут тренеру в личку",
        "Переносы, оплата и вопросы по абонементу теряются в переписке с десятками семей.",
        "Чат и уведомления клуба",
      ],
    ],
    dayKicker: "Тренировочный день",
    dayTitle: ["Тренер работает с группой.", "Учёт ведётся сам."],
    daySub:
      "Младшие заканчивают разминку, старшая группа выходит на ковёр. Никаких тетрадей и пересчёта абонементов.",
    day: [
      ["До", "Расписание дня", "Какие группы, в каком зале и у какого тренера."],
      ["В зале", "Отметка в журнале", "Тренер отмечает пришедших за минуту."],
      ["После", "Учёт уже готов", "Занятия списаны, родители видят посещение."],
    ],
    appTitle: ["Тренеру, родителям", "и спортсменам"],
    appTabs: appTabs(),
    appNote: "«Тигр» — демонстрационный клуб внутри приложения.",
    rulesTitle: ["Настраивается под то,", "как устроена ваша секция."],
    rules: [
      [
        TbUsersGroup,
        "Группы по возрасту и уровню",
        "От малышей до старших групп — у каждой свой тренер, зал и расписание.",
      ],
      MEMBERSHIP_RULE,
      [
        TbBuildingCommunity,
        "Несколько залов",
        "Филиалы и залы в одном кабинете — у каждого своё расписание, тренеры и группы.",
      ],
      RESCHEDULE_RULE,
    ],
    regTitle: ["Запустите секцию", "в Бай.Спорт сегодня"],
    faq: [
      [
        "Подойдёт ли для групп разного возраста и уровня?",
        "Да. Заводите группы по возрасту или уровню подготовки, назначайте тренеров и залы — всё в одном расписании.",
      ],
      PARENT_FAQ,
      JOURNAL_FAQ,
      ...COMMON_FAQ,
    ],
  },

  plavanie: {
    id: "plavanie",
    path: `${BASE}/dlya-plavaniya`,
    navTitle: "Плавание",
    navText: "Школы и бассейны",
    icon: TbSwimming,
    pill: "Для школ плавания и бассейнов",
    heroLines: ["Состав у бортика.", "Учёт без Excel."],
    heroLead:
      "Группы, тренеры и бассейны, журнал посещений, абонементы и связь с родителями — в одном сервисе для школ плавания.",
    classLead:
      "У бортика открываете занятие из расписания и отмечаете пришедших — остаток абонемента и посещение уходят к родителю сами.",
    sports: ["Обучение детей", "Спортивное плавание", "Взрослые группы", "Аквааэробика"],
    photos: nichePhotos("plavanie", "0% 50%"),
    stat: { value: 198, delta: "8%" },
    lesson: { meta: "Сегодня · 16:00 · бассейн 1", title: "Обучение, 7–9 лет", came: 9, total: 10 },
    strip: [
      [TbSwimming, "Группы и тренеры", "Детские и взрослые группы в одном расписании."],
      [TbChecklist, "Журнал у бортика", "Отметили группу — занятия списались сами."],
      [TbTicket, "Абонементы и оплаты", "Остатки, оплаты и должники без тетради."],
      [TbBell, "Переносы без обзвона", "Push-уведомление ученикам и родителям."],
    ],
    painsTitle: ["Групп всё больше.", "Тетрадь уже не справляется."],
    pains: [
      [
        "Кто в какой группе — знает только тренер",
        "Списки групп лежат в разных тетрадях и чатах. Сменился тренер — и списки собирают заново.",
        "Составы групп в одной базе",
      ],
      [
        "Остаток занятий считают вручную",
        "Родитель спрашивает, сколько занятий осталось, а администратор листает записи за месяц.",
        "Остаток считается сам",
      ],
      [
        "Переносы — это обзвон",
        "Бассейн закрыли на профилактику — и администратор вручную предупреждает десятки семей.",
        "Push-уведомление о переносе",
      ],
    ],
    dayKicker: "День в бассейне",
    dayTitle: ["Тренер у бортика.", "Учёт ведётся сам."],
    daySub:
      "Младшая группа выходит из воды, взрослые идут на дорожки. Никаких тетрадей и пересчёта абонементов.",
    day: [
      ["До", "Расписание дня", "Какие группы, в каком бассейне и у какого тренера."],
      ["У бортика", "Отметка в журнале", "Тренер отмечает пришедших за минуту."],
      ["После", "Учёт уже готов", "Занятия списаны, родители видят посещение."],
    ],
    appTitle: ["Тренеру, родителям", "и ученикам"],
    appTabs: appTabs(),
    appNote: "«Тигр» — демонстрационный клуб внутри приложения.",
    rulesTitle: ["Настраивается под то,", "как работает ваша школа."],
    rules: [
      [
        TbUsersGroup,
        "Детские и взрослые группы",
        "Обучение, спортивные и взрослые группы — у каждой свой тренер, бассейн и расписание.",
      ],
      MEMBERSHIP_RULE,
      [
        TbBuildingCommunity,
        "Несколько бассейнов",
        "Площадки и бассейны в одном кабинете — у каждого своё расписание, тренеры и группы.",
      ],
      RESCHEDULE_RULE,
    ],
    regTitle: ["Запустите школу", "в Бай.Спорт сегодня"],
    faq: [
      [
        "Подойдёт ли для школы с несколькими бассейнами?",
        "Да. Заведите площадки как филиалы или залы — у каждой своё расписание, тренеры и группы, а учёт общий.",
      ],
      PARENT_FAQ,
      JOURNAL_FAQ,
      ...COMMON_FAQ,
    ],
  },

  futbol: {
    id: "futbol",
    path: `${BASE}/dlya-futbola`,
    navTitle: "Футбол",
    navText: "Секции и футбольные школы",
    icon: TbBallFootball,
    pill: "Для футбольных секций и школ",
    heroLines: ["Состав на поле.", "Учёт без Excel."],
    heroLead:
      "Группы по годам рождения, журнал тренировок, абонементы и связь с родителями — в одном сервисе для футбольных школ.",
    classLead:
      "На поле открываете тренировку из расписания и отмечаете пришедших — остаток абонемента и посещение уходят к родителю сами.",
    sports: ["U7–U9", "U10–U12", "U13–U15", "Мини-футбол", "Взрослые любители"],
    photos: nichePhotos("futbol", "0% 50%"),
    stat: { value: 212, delta: "11%" },
    lesson: { meta: "Сегодня · 18:30 · поле 2", title: "Группа 2015 г. р.", came: 18, total: 20 },
    strip: [
      [TbBallFootball, "Группы по годам", "Составы по годам рождения, тренеры и поля."],
      [TbChecklist, "Журнал тренировок", "Отметили группу — занятия списались сами."],
      [TbTicket, "Абонементы и долги", "Кто оплатил месяц — видно без сверки."],
      [TbMessageCircle, "Родители на связи", "Расписание, остаток и чат в приложении."],
    ],
    painsTitle: ["Команд всё больше.", "Тетрадь уже не справляется."],
    pains: [
      [
        "Состав группы — в чате тренера",
        "Кто ходит в группу 2015 года, знает только тренер. Новый тренер начинает с переписки.",
        "Составы групп в одной базе",
      ],
      [
        "Оплаты сверяют вручную",
        "Кто оплатил месяц, а кто нет — администратор сверяет переводы с таблицей.",
        "Оплаты и долги в одной базе",
      ],
      [
        "Переносы теряются в чатах",
        "Поле заняли или пошёл дождь — сообщение о переносе тонет среди десятков других.",
        "Push-уведомление о переносе",
      ],
    ],
    dayKicker: "Тренировочный вечер",
    dayTitle: ["Тренер ведёт тренировку.", "Учёт ведётся сам."],
    daySub:
      "Младшие заканчивают на одном поле, старшая группа выходит на другое. Никаких тетрадей и пересчёта абонементов.",
    day: [
      ["До", "Расписание дня", "Какие группы, на каком поле и у какого тренера."],
      ["На поле", "Отметка в журнале", "Тренер отмечает пришедших за минуту."],
      ["После", "Учёт уже готов", "Занятия списаны, родители видят посещение."],
    ],
    appTitle: ["Тренеру, родителям", "и игрокам"],
    appTabs: appTabs(),
    appNote: "«Тигр» — демонстрационный клуб внутри приложения.",
    rulesTitle: ["Настраивается под то,", "как устроена ваша школа."],
    rules: [
      [
        TbUsersGroup,
        "Группы по годам рождения",
        "Младшие, средние и старшие группы — у каждой свой тренер, поле и расписание.",
      ],
      MEMBERSHIP_RULE,
      [
        TbBuildingCommunity,
        "Несколько полей и филиалов",
        "Площадки школы в одном кабинете — у каждой своё расписание, тренеры и группы.",
      ],
      RESCHEDULE_RULE,
    ],
    regTitle: ["Запустите школу", "в Бай.Спорт сегодня"],
    faq: [
      [
        "Подойдёт ли для групп по годам рождения?",
        "Да. Заводите группы по годам или уровню, назначайте тренеров и поля — всё в одном расписании школы.",
      ],
      PARENT_FAQ,
      JOURNAL_FAQ,
      ...COMMON_FAQ,
    ],
  },

  fitnes: {
    id: "fitnes",
    path: `${BASE}/dlya-fitnesa`,
    navTitle: "Фитнес-клубы",
    navText: "Группы, персональные и залы",
    icon: TbBarbell,
    pill: "Для фитнес-клубов и студий",
    heroLines: ["Зал работает.", "Учёт тоже."],
    heroLead:
      "Групповые и персональные занятия, залы и тренеры, журнал и абонементы — в одном сервисе для фитнес-клуба.",
    classLead:
      "В клубе открываете занятие из расписания и отмечаете пришедших — остаток абонемента сразу виден клиенту.",
    sports: ["Силовые", "Функционал", "Кроссфит", "Групповые", "Персональные"],
    photos: nichePhotos("fitnes"),
    stat: { value: 240, delta: "6%" },
    lesson: { meta: "Сегодня · 19:00 · зал 1", title: "Функционал, вечер", came: 16, total: 18 },
    strip: [
      [TbBarbell, "Группы и персональные", "Оба формата в одном расписании залов и тренеров."],
      [TbChecklist, "Журнал занятия", "Отметили пришедших — занятия списались сами."],
      [TbTicket, "Абонементы и оплаты", "Пакеты, сроки и должники без таблицы."],
      [TbMessageCircle, "Клиенты на связи", "Расписание, остаток и чат в приложении."],
    ],
    painsTitle: ["Клуб растёт.", "Таблицы уже не справляются."],
    pains: [
      [
        "Расписание живёт в нескольких файлах",
        "Группы, персональные, залы и тренеры правят в разных таблицах. Перенос — это ручная рассылка.",
        "Одно расписание клуба",
      ],
      [
        "Кто оплатил — сверяют вручную",
        "Администратор сверяет переводы со списком абонементов в конце дня.",
        "Оплаты и долги в одной базе",
      ],
      [
        "Клиенты пишут в мессенджер",
        "Во сколько занятие, сколько осталось, как оплатить — вопросы идут администратору в личку.",
        "Ответы — в приложении клуба",
      ],
    ],
    dayKicker: "Вечер в клубе",
    dayTitle: ["Тренер ведёт занятие.", "Учёт ведётся сам."],
    daySub:
      "В одном зале заканчивается функционал, в соседнем начинается персональная. Никаких таблиц и пересчёта абонементов.",
    day: [
      ["До", "Расписание дня", "Какие занятия, в каком зале и у какого тренера."],
      ["В зале", "Отметка в журнале", "Тренер отмечает пришедших за минуту."],
      ["После", "Учёт уже готов", "Занятия списаны, клиент видит остаток."],
    ],
    appTitle: ["Тренеру, клиентам", "и администратору"],
    appTabs: appTabs(ADULT_TAB),
    appNote: "«Тигр» — демонстрационный клуб внутри приложения.",
    rulesTitle: ["Настраивается под то,", "как работает ваш клуб."],
    rules: [
      [
        TbBarbell,
        "Группы и персональные",
        "Групповые занятия и персональные тренировки — у каждого свой тренер, зал и время.",
      ],
      MEMBERSHIP_RULE,
      [
        TbBuildingCommunity,
        "Несколько залов",
        "Залы и филиалы в одном кабинете — у каждого своё расписание и тренеры.",
      ],
      RESCHEDULE_RULE,
    ],
    regTitle: ["Запустите клуб", "в Бай.Спорт сегодня"],
    faq: [
      [
        "Подойдёт ли для клуба с групповыми и персональными?",
        "Да. Группы и персональные занятия живут в одном расписании: у каждого свой тренер, зал и время.",
      ],
      JOURNAL_FAQ,
      ...COMMON_FAQ,
    ],
  },

  yoga: {
    id: "yoga",
    path: `${BASE}/dlya-yogi`,
    navTitle: "Йога и пилатес",
    navText: "Студии йоги и пилатеса",
    icon: TbYoga,
    pill: "Для студий йоги и пилатеса",
    heroLines: ["Тишина в зале.", "Порядок в студии."],
    heroLead:
      "Расписание классов, абонементы по занятиям и по сроку, заморозка и разовые визиты — в одном сервисе для студии.",
    classLead:
      "В зале открываете класс из расписания и отмечаете пришедших — остаток абонемента сразу виден ученику.",
    sports: ["Хатха", "Виньяса", "Пилатес", "Реформер", "Медитация"],
    photos: nichePhotos("yoga"),
    stat: { value: 128, delta: "8%" },
    lesson: { meta: "Сегодня · 10:00 · зал 2", title: "Виньяса, утро", came: 12, total: 14 },
    strip: [
      [TbYoga, "Классы и преподаватели", "Утренние и вечерние группы в одном расписании."],
      [TbTicket, "Абонементы и разовые", "По занятиям или по сроку, заморозка и разовые визиты."],
      [TbChecklist, "Журнал класса", "Отметили пришедших — занятия списались сами."],
      [TbMessageCircle, "Ученики на связи", "Расписание, остаток и чат в приложении."],
    ],
    painsTitle: ["Студия растёт.", "Таблица уже не справляется."],
    pains: [
      [
        "Абонементы ведут в таблице",
        "У кого пакет занятий, у кого месяц, у кого заморозка — администратор считает вручную.",
        "Остаток считается сам",
      ],
      [
        "Разовые теряются",
        "Человек пришёл один раз, оплату записали в чат, в общий учёт визит не попал.",
        "Разовые в том же журнале",
      ],
      [
        "Ученики спрашивают одно и то же",
        "Во сколько класс и сколько занятий осталось — пишут преподавателю в мессенджер.",
        "Ответы — в приложении студии",
      ],
    ],
    dayKicker: "День в студии",
    dayTitle: ["Преподаватель ведёт класс.", "Учёт ведётся сам."],
    daySub:
      "Утром виньяса, вечером пилатес. Никаких таблиц и пересчёта абонементов.",
    day: [
      ["До", "Расписание дня", "Какие классы, в каком зале и у какого преподавателя."],
      ["В зале", "Отметка в журнале", "Преподаватель отмечает пришедших за минуту."],
      ["После", "Учёт уже готов", "Занятия списаны, ученик видит остаток."],
    ],
    appTitle: ["Преподавателю", "и ученикам"],
    appTabs: appTabs(ADULT_TAB, "Преподавателю"),
    appNote: "«Тигр» — демонстрационный клуб внутри приложения.",
    rulesTitle: ["Настраивается под то,", "как работает ваша студия."],
    rules: [
      [
        TbYoga,
        "Несколько направлений",
        "Хатха, виньяса, пилатес — у каждого свои группы, преподаватели и залы.",
      ],
      MEMBERSHIP_RULE,
      [
        TbBuildingCommunity,
        "Залы студии",
        "Все залы в одном кабинете — у каждого своё расписание и преподаватели.",
      ],
      RESCHEDULE_RULE,
    ],
    regTitle: ["Запустите студию", "в Бай.Спорт сегодня"],
    faq: [
      [
        "Можно ли вести абонементы по занятиям и по сроку?",
        "Да. Пакет занятий, абонемент на срок, заморозка и разовые визиты живут в одном учёте.",
      ],
      JOURNAL_FAQ,
      ...COMMON_FAQ,
    ],
  },

  deti: {
    id: "deti",
    path: `${BASE}/dlya-detskih-sekcij`,
    navTitle: "Детские секции",
    navText: "Группы и родители",
    icon: TbMoodKid,
    pill: "Для детских секций",
    heroLines: ["Дети на тренировке.", "Родители в курсе."],
    heroLead:
      "Группы по возрасту, журнал посещений, абонементы и приложение для родителей — в одном сервисе для детской секции.",
    classLead:
      "Открываете группу из расписания и отмечаете пришедших — посещение и остаток абонемента уходят к родителю сами.",
    sports: ["Младшие", "Средние", "Старшие", "Начинающие"],
    photos: nichePhotos("deti"),
    stat: { value: 156, delta: "7%" },
    lesson: { meta: "Сегодня · 17:00 · зал 1", title: "Младшая группа", came: 11, total: 12 },
    strip: [
      [TbMoodKid, "Группы по возрасту", "Младшие, средние и старшие — свой тренер и зал."],
      [TbChecklist, "Журнал занятия", "Отметили группу — занятия списались сами."],
      [TbTicket, "Абонементы и оплаты", "Остаток и долг видны без тетради."],
      [TbMessageCircle, "Родители на связи", "Расписание, посещения и чат в приложении."],
    ],
    painsTitle: ["Групп всё больше.", "Тетрадь уже не справляется."],
    pains: [
      [
        "Состав группы знает только тренер",
        "Кто ходит в младшую, записано в тетради. Тренер заболел — список собирают заново.",
        "Составы групп в одной базе",
      ],
      [
        "Родитель спрашивает остаток",
        "Сколько тренировок осталось — администратор листает записи за месяц.",
        "Остаток считается сам",
      ],
      [
        "Родители пишут тренеру в личку",
        "Переносы, оплата и вопросы по ребёнку теряются в переписке с десятками семей.",
        "Чат и уведомления клуба",
      ],
    ],
    dayKicker: "Вечер в секции",
    dayTitle: ["Тренер ведёт группу.", "Родители видят посещение."],
    daySub:
      "Младшие заканчивают, старшая группа выходит в зал. Никаких тетрадей и пересчёта абонементов.",
    day: [
      ["До", "Расписание дня", "Какие группы, в каком зале и у какого тренера."],
      ["В зале", "Отметка в журнале", "Тренер отмечает пришедших за минуту."],
      ["После", "Родитель уже видит", "Занятие списано, посещение есть в приложении."],
    ],
    appTitle: ["Тренеру, родителям", "и ученикам"],
    appTabs: appTabs(),
    appNote: "«Тигр» — демонстрационный клуб внутри приложения.",
    rulesTitle: ["Настраивается под то,", "как устроена ваша секция."],
    rules: [
      [
        TbUsersGroup,
        "Группы по возрасту",
        "Младшие, средние и старшие — у каждой свой тренер, зал и расписание.",
      ],
      MEMBERSHIP_RULE,
      [
        TbBuildingCommunity,
        "Несколько залов",
        "Площадки секции в одном кабинете — у каждой своё расписание и тренеры.",
      ],
      RESCHEDULE_RULE,
    ],
    regTitle: ["Запустите секцию", "в Бай.Спорт сегодня"],
    faq: [
      [
        "Подойдёт ли для нескольких детских групп?",
        "Да. Заводите группы по возрасту, назначайте тренеров и залы — родители видят расписание и посещения своего ребёнка.",
      ],
      PARENT_FAQ,
      JOURNAL_FAQ,
      ...COMMON_FAQ,
    ],
  },

  rastyazhka: {
    id: "rastyazhka",
    path: `${BASE}/dlya-rastyazhki`,
    navTitle: "Студии растяжки",
    navText: "Группы и персональные",
    icon: TbStretching2,
    pill: "Для студий растяжки",
    heroLines: ["Студия работает.", "Учёт тоже."],
    heroLead:
      "Небольшие группы и персональные, абонементы и разовые визиты — в одном сервисе для студии растяжки.",
    classLead:
      "Открываете группу или персональное из расписания и отмечаете пришедших — остаток абонемента сразу виден клиенту.",
    sports: ["Растяжка", "Шпагат", "МФР", "Здоровая спина", "Персональные"],
    photos: nichePhotos("rastyazhka"),
    stat: { value: 96, delta: "10%" },
    lesson: { meta: "Сегодня · 20:00 · зал 1", title: "Растяжка, все уровни", came: 9, total: 12 },
    strip: [
      [TbStretching2, "Группы и персональные", "Небольшие классы и личные занятия в одном расписании."],
      [TbTicket, "Абонементы и разовые", "Пакеты, сроки и разовые визиты без таблицы."],
      [TbChecklist, "Журнал класса", "Отметили пришедших — занятия списались сами."],
      [TbMessageCircle, "Клиенты на связи", "Расписание, остаток и чат в приложении."],
    ],
    painsTitle: ["Клиентов всё больше.", "Таблицы уже не тянут."],
    pains: [
      [
        "Группы и персональные в разных записях",
        "Класс на вечер в одной таблице, персональные — в заметках администратора.",
        "Одно расписание студии",
      ],
      [
        "Разовый визит не попадает в учёт",
        "Оплату за одно занятие написали в переписке, в абонементах её нет.",
        "Разовые в том же журнале",
      ],
      [
        "Клиенты пишут в мессенджер",
        "Во сколько класс и сколько занятий осталось — спрашивают администратора лично.",
        "Ответы — в приложении студии",
      ],
    ],
    dayKicker: "Вечер в студии",
    dayTitle: ["Преподаватель ведёт класс.", "Учёт ведётся сам."],
    daySub:
      "В зале небольшая группа, следом персональное. Никаких таблиц и пересчёта абонементов.",
    day: [
      ["До", "Расписание дня", "Какие классы, в каком зале и у какого преподавателя."],
      ["В зале", "Отметка в журнале", "Преподаватель отмечает пришедших за минуту."],
      ["После", "Учёт уже готов", "Занятия списаны, клиент видит остаток."],
    ],
    appTitle: ["Преподавателю", "и клиентам"],
    appTabs: appTabs(ADULT_TAB, "Преподавателю"),
    appNote: "«Тигр» — демонстрационный клуб внутри приложения.",
    rulesTitle: ["Настраивается под то,", "как работает ваша студия."],
    rules: [
      [
        TbStretching2,
        "Группы и персональные",
        "Небольшие классы и личные занятия — у каждого свой преподаватель, зал и время.",
      ],
      MEMBERSHIP_RULE,
      [
        TbBuildingCommunity,
        "Залы студии",
        "Все залы в одном кабинете — у каждого своё расписание.",
      ],
      RESCHEDULE_RULE,
    ],
    regTitle: ["Запустите студию", "в Бай.Спорт сегодня"],
    faq: [
      [
        "Подойдёт ли для небольших групп и персональных?",
        "Да. Групповые классы и персональные занятия живут в одном расписании, разовые визиты отмечаются там же.",
      ],
      JOURNAL_FAQ,
      ...COMMON_FAQ,
    ],
  },

  saykl: {
    id: "saykl",
    path: `${BASE}/dlya-saykla`,
    navTitle: "Сайкл-студии",
    navText: "Расписание классов и явка",
    icon: TbBike,
    pill: "Для сайкл-студий",
    heroLines: ["Зал работает.", "Явка тоже."],
    heroLead:
      "Расписание классов, абонементы и отметка, кто придёт, — в одном сервисе для сайкл-студии.",
    classLead:
      "Клиент отмечает, придёт ли на класс. После журнала занятие списывается, остаток виден в приложении.",
    sports: ["Сайкл", "Интервалы", "Новички", "Утро", "Вечер"],
    photos: nichePhotos("saykl"),
    stat: { value: 210, delta: "5%" },
    lesson: { meta: "Сегодня · 07:30 · зал", title: "Утренний сайкл", came: 18, total: 20 },
    strip: [
      [TbBike, "Классы по времени", "Утро, день и вечер — тренер и зал в расписании."],
      [TbChecklist, "Кто придёт", "Клиент отмечает «приду» или «не приду» до занятия."],
      [TbTicket, "Абонементы", "Пакеты занятий и сроки, списание после класса."],
      [TbBell, "Перенос без рассылки", "Push тем, кто записан на этот класс."],
    ],
    painsTitle: ["Классов всё больше.", "Явку собирают вручную."],
    pains: [
      [
        "Кто придёт — список в чате",
        "Утренний класс собирают сообщениями. К началу список уже устарел.",
        "Отметка «приду» в приложении",
      ],
      [
        "Абонементы считают после класса",
        "Кто был и сколько занятий осталось, администратор переписывает вручную.",
        "Списание из журнала",
      ],
      [
        "Перенос — это рассылка",
        "Тренер заболел, и администратор пишет каждому в мессенджер.",
        "Push о переносе",
      ],
    ],
    dayKicker: "Утро в студии",
    dayTitle: ["Тренер ведёт класс.", "Явка уже собрана."],
    daySub:
      "До начала видно, кто придёт. После класса занятия списаны сами.",
    day: [
      ["До", "Кто отметился", "Клиенты отмечают, придут ли на класс."],
      ["В зале", "Отметка в журнале", "Тренер отмечает пришедших за минуту."],
      ["После", "Учёт уже готов", "Занятия списаны, клиент видит остаток."],
    ],
    appTitle: ["Тренеру", "и клиентам"],
    appTabs: appTabs(ADULT_TAB),
    appNote: "«Тигр» — демонстрационный клуб внутри приложения.",
    rulesTitle: ["Настраивается под то,", "как работает ваша студия."],
    rules: [
      [
        TbBike,
        "Классы по расписанию",
        "Утренние, дневные и вечерние — у каждого свой тренер и зал.",
      ],
      MEMBERSHIP_RULE,
      [
        TbChecklist,
        "Отметка явки",
        "Клиент заранее отмечает, придёт ли. Тренер видит это до начала класса.",
      ],
      RESCHEDULE_RULE,
    ],
    regTitle: ["Запустите студию", "в Бай.Спорт сегодня"],
    faq: [
      [
        "Клиент может отметить, что придёт?",
        "Да. На ближайшем занятии клиент отмечает «приду» или «не приду». Тренер видит это до начала класса.",
      ],
      JOURNAL_FAQ,
      ...COMMON_FAQ,
    ],
  },

  shkoly: {
    id: "shkoly",
    path: `${BASE}/dlya-sportivnyh-shkol`,
    navTitle: "Спортивные школы",
    navText: "Несколько направлений и групп",
    icon: TbSchool,
    pill: "Для спортивных школ",
    heroLines: ["Несколько направлений.", "Один учёт."],
    heroLead:
      "Направления, группы по возрасту, тренеры, журнал и абонементы — в одном сервисе для спортивной школы.",
    classLead:
      "У каждого направления свои группы и тренеры. Отметка в журнале списывает занятие — родитель видит посещение сам.",
    sports: ["ОФП", "Игровые", "Единоборства", "Плавание", "Гимнастика", "Лыжи и сноуборд"],
    photos: nichePhotos("shkoly"),
    stat: { value: 320, delta: "4%" },
    lesson: { meta: "Сегодня · 16:30 · зал 2", title: "ОФП, 8–10 лет", came: 14, total: 16 },
    strip: [
      [TbSchool, "Направления и группы", "У каждого направления свои группы, тренеры и залы."],
      [TbChecklist, "Журнал тренировки", "Отметили группу — занятия списались сами."],
      [TbTicket, "Абонементы и оплаты", "Остатки и долги по всей школе."],
      [TbMessageCircle, "Родители на связи", "Расписание, посещения и чат в приложении."],
    ],
    painsTitle: ["Направлений всё больше.", "Журналы уже не сходятся."],
    pains: [
      [
        "У каждого направления свой журнал",
        "ОФП, игровые и единоборства ведут отдельно. Общую картину собирают к концу месяца.",
        "Все группы в одном кабинете",
      ],
      [
        "Тренер ушёл — списки остались у него",
        "Состав группы и кто оплатил живут в тетради тренера.",
        "Составы и оплаты в базе школы",
      ],
      [
        "Родители не видят расписание",
        "В какой зал и к какому тренеру — узнают из сообщения накануне.",
        "Расписание в приложении",
      ],
    ],
    dayKicker: "День в школе",
    dayTitle: ["Тренеры ведут группы.", "Учёт общий."],
    daySub:
      "В разных залах идут разные направления. Посещения и абонементы сходятся сами.",
    day: [
      ["До", "Расписание дня", "Какие группы, в каком зале и у какого тренера."],
      ["В зале", "Отметка в журнале", "Тренер отмечает пришедших за минуту."],
      ["После", "Учёт уже готов", "Занятия списаны, родители видят посещение."],
    ],
    appTitle: ["Тренеру, родителям", "и ученикам"],
    appTabs: appTabs(),
    appNote: "«Тигр» — демонстрационный клуб внутри приложения.",
    rulesTitle: ["Настраивается под то,", "как устроена ваша школа."],
    rules: [
      [
        TbSchool,
        "Несколько направлений",
        "У каждого направления свои группы, тренеры, залы и расписание.",
      ],
      MEMBERSHIP_RULE,
      [
        TbBuildingCommunity,
        "Залы школы",
        "Все площадки в одном кабинете — учёт по школе общий.",
      ],
      RESCHEDULE_RULE,
    ],
    regTitle: ["Запустите школу", "в Бай.Спорт сегодня"],
    faq: [
      [
        "Подойдёт ли школе с несколькими направлениями?",
        "Да. Направления и группы заводятся отдельно, тренеры видят свои составы, а учёт абонементов и посещений общий.",
      ],
      PARENT_FAQ,
      JOURNAL_FAQ,
      ...COMMON_FAQ,
    ],
  },

  seti: {
    id: "seti",
    path: `${BASE}/dlya-setey`,
    navTitle: "Сети клубов",
    navText: "Несколько филиалов",
    icon: TbBuildingCommunity,
    pill: "Для сетей клубов",
    heroLines: ["Несколько филиалов.", "Один кабинет."],
    heroLead:
      "У каждого филиала своё расписание, залы и тренеры. Владелец видит все площадки в одном сервисе.",
    classLead:
      "У филиала своё расписание и свои тренеры. Отметка на занятии сразу попадает в общий учёт сети.",
    sports: ["Филиалы", "Залы", "Тренеры", "Общий учёт"],
    photos: nichePhotos("seti"),
    stat: { value: 480, delta: "3%" },
    lesson: { meta: "Сегодня · 18:00 · филиал 2", title: "Силовая, вечер", came: 15, total: 18 },
    strip: [
      [TbBuildingCommunity, "Филиалы отдельно", "Своё расписание, свои залы и свои тренеры."],
      [TbUsersGroup, "Общая база клиентов", "Карточка клиента одна на всю сеть."],
      [TbChecklist, "Журнал площадки", "Тренер отмечает занятие в своём филиале."],
      [TbTicket, "Оплаты по сети", "Кто оплатил и кто должен — без сводных таблиц."],
    ],
    painsTitle: ["Площадок всё больше.", "Сводки собирают вручную."],
    pains: [
      [
        "У каждого филиала своя таблица",
        "Расписание, тренеры и оплаты живут в разных файлах. Общую картину собирает владелец.",
        "Все филиалы в одном кабинете",
      ],
      [
        "Клиент ходит на две площадки",
        "Абонемент заведён в одном филиале, на втором о нём не знают.",
        "Одна карточка на сеть",
      ],
      [
        "Перенос знают только в одном зале",
        "Занятие перенесли, а клиенты другого филиала узнают об этом из чата.",
        "Уведомление от клуба",
      ],
    ],
    dayKicker: "День сети",
    dayTitle: ["Филиалы работают сами.", "Картина общая."],
    daySub:
      "В каждом зале своё расписание. Посещения и оплаты сходятся в одном кабинете.",
    day: [
      ["Утро", "Своё расписание", "У филиала свои группы, залы и тренеры."],
      ["День", "Журнал площадки", "Тренер отмечает пришедших у себя."],
      ["Вечер", "Общий учёт", "Владелец видит посещения и оплаты по всем площадкам."],
    ],
    appTitle: ["Тренеру филиала", "и клиентам"],
    appTabs: appTabs(ADULT_TAB),
    appNote: "«Тигр» — демонстрационный клуб внутри приложения.",
    rulesTitle: ["Настраивается под то,", "как устроена ваша сеть."],
    rules: [
      [
        TbBuildingCommunity,
        "Филиалы и залы",
        "У каждой площадки своё расписание, тренеры и группы. Кабинет владельца один.",
      ],
      MEMBERSHIP_RULE,
      [
        TbUsersGroup,
        "Клиенты сети",
        "Карточка, абонемент и посещения общие, даже если человек ходит на разные площадки.",
      ],
      RESCHEDULE_RULE,
    ],
    regTitle: ["Запустите сеть", "в Бай.Спорт сегодня"],
    faq: [
      [
        "Можно ли вести несколько филиалов?",
        "Да. Филиалы, залы, направления и тренеры настраиваются отдельно, владелец видит общую картину по всем площадкам.",
      ],
      JOURNAL_FAQ,
      ...COMMON_FAQ,
    ],
  },
};

export const NICHE_ORDER = [
  "edinoborstva",
  "tancy",
  "gimnastika",
  "plavanie",
  "futbol",
  "fitnes",
  "yoga",
  "deti",
  "rastyazhka",
  "saykl",
  "shkoly",
  "seti",
];
